import { useMemo } from 'react'

import { Modal } from '../Modal'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ManageUserProgramForm } from 'Components/Modal/ManageUserProgramsModal/ManageUserProgramsForm'

import { ModalType, usePeoplePageContext } from 'Contexts/PeoplePageContext'
import { useEmployerUsersContext } from 'Contexts/EmployerUsersContext'

import { MediumBoldText, ThinDarkGreenText } from 'Utils/styles/text'
import { FlexColumn } from 'Utils/styles/spacing'

export const ManageUserProgramsModal = () => {
  const {
    state: { modal, actionableUserId },
    setModal
  } = usePeoplePageContext()

  const {
    state: { users }
  } = useEmployerUsersContext()

  const user = useMemo(() => {
    return users.find((user) => user.id == actionableUserId)
  }, [users, actionableUserId])

  const setShowModal = (show: boolean) => setModal(show ? ModalType.ManageUserPrograms : undefined)

  return (
    <Modal showModal={modal == ModalType.ManageUserPrograms} setShowModal={setShowModal}>
      <ModalHeader>Manage Benefits</ModalHeader>

      <FlexColumn>
        <MediumBoldText>
          {user?.userInfo.firstName} {user?.userInfo.lastName}
        </MediumBoldText>
        <ThinDarkGreenText>{user?.userInfo.email}</ThinDarkGreenText>
      </FlexColumn>

      <ManageUserProgramForm user={user} />
    </Modal>
  )
}
